import { useMemo, useRef } from 'react';
import { useDataModel, useLazyDataModel } from '@thd-nucleus/data-sources';
import {
  determineLoadingState, determineErrorState, useDataSourceOpts
} from '../common/utils/ContextUtils';
import { ENDPOINTS } from '../core/Constants';

export const useFetchChallengesInfo = ({ challengeType = undefined, skip = false } = {}) => {
  const challengesDataRef = useRef({});
  const opts = useDataSourceOpts({ skip }).opts;
  const challengesOpts = {
    ...opts,
    variables: {
      ...opts.variables, // 'sweepstakes', etc.
      challengeType,
    }
  };

  const challengesResponse = useDataModel(ENDPOINTS.CHALLENGES_INFO, challengesOpts);
  challengesDataRef.current = challengesResponse?.data && challengesResponse?.data[ENDPOINTS.CHALLENGES_INFO];

  const challengesData = challengesDataRef.current;
  const isLoadingChallenges = determineLoadingState(challengesResponse);
  const hasErrorChallenges = determineErrorState(challengesResponse);
  const refreshChallengeData = () => challengesResponse.refetch();

  return useMemo(() => ({
    isLoadingChallenges,
    hasErrorChallenges,
    challengesData,
    refreshChallengeData
  }), [challengesData, hasErrorChallenges, isLoadingChallenges]);
};

export const useFetchChallengesAccept = (props) => {
  const { acceptChallengeInput } = props ?? {};
  const acceptChallengeDataRef = useRef({});
  const opts = useDataSourceOpts().opts;
  if (acceptChallengeInput?.id && opts && opts.variables) {
    const input = { id: acceptChallengeInput.id };

    if (acceptChallengeInput.customerChallengeId !== null
        && acceptChallengeInput.customerChallengeId !== undefined) {
      input.customerChallengeId = acceptChallengeInput.customerChallengeId;
    }

    if (acceptChallengeInput.isV2 !== null
        && acceptChallengeInput.isV2 !== undefined) {
      input.isV2 = acceptChallengeInput.isV2;
    }

    opts.variables.challengeInput = input;
  }

  const [getAcceptChallenge, acceptResponse] = useLazyDataModel(ENDPOINTS.ACCEPT_CHALLENGES, opts);
  acceptChallengeDataRef.current = acceptResponse?.data && acceptResponse?.data[ENDPOINTS.ACCEPT_CHALLENGES];

  const acceptChallengeData = acceptChallengeDataRef.current;

  return useMemo(() => ({
    isLoadingAccept: acceptResponse.loading,
    hasErrorAccept: acceptResponse.error,
    acceptChallengeData,
    getAcceptChallenge
  }), [acceptResponse]);
};
